import React from 'react';
import { FaMapMarkerAlt, FaCalendarAlt, FaUserTie, FaClock, FaEdit, FaTrash } from 'react-icons/fa';
import StatusBadge from './JobStatusBadge';
import './shared.css';

const JobCard = ({ job, onClick, compact = false, onEdit, onDelete, canEdit = true, canDelete = true, editDisabledReason, deleteDisabledReason }) => {
  const formatDate = (d) => {
    if (!d) return '-';
    return new Date(d).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
  };

  const formatDuration = (mins) => {
    if (!mins) return null;
    const h = Math.floor(mins / 60);
    const m = mins % 60;
    return h > 0 ? `${h}h ${m}m` : `${m}m`;
  };

  if (compact) {
    return (
      <div className="cs-job-card compact" onClick={onClick} role="button" tabIndex={0}>
        <div className="cs-job-card-top">
          <span className="cs-job-title">{job.title}</span>
          <StatusBadge status={job.status} size="small" />
        </div>
        <div className="cs-job-meta">
          <span><FaMapMarkerAlt /> {job.property_name || job.area}</span>
          <span><FaCalendarAlt /> {formatDate(job.scheduled_date)}</span>
        </div>
      </div>
    );
  }

  const handleCardClick = (e) => {
    if (e.target.closest('.cs-job-card-actions')) return;
    onClick?.();
  };

  return (
    <div className="cs-job-card" onClick={handleCardClick} role="button" tabIndex={0}>
      <div className="cs-job-card-top">
        <div>
          <h4 className="cs-job-title">{job.title}</h4>
          <span className="cs-job-area">{job.area}</span>
        </div>
        <StatusBadge status={job.status} />
      </div>
      {job.description && <p className="cs-job-desc">{job.description}</p>}
      <div className="cs-job-meta">
        <span><FaMapMarkerAlt /> {job.property_name || 'Property'}</span>
        <span><FaCalendarAlt /> {formatDate(job.scheduled_date)}</span>
        {job.contractor_first_name && (
          <span><FaUserTie /> {job.contractor_first_name} {job.contractor_last_name}</span>
        )}
        {job.duration_minutes && (
          <span><FaClock /> {formatDuration(job.duration_minutes)}</span>
        )}
      </div>
      {(onEdit != null || onDelete != null) && (
        <div className="cs-job-card-actions" onClick={e => e.stopPropagation()}>
          {onEdit != null && (
            <button
              type="button"
              className="cs-btn-icon cs-btn-edit"
              disabled={!canEdit}
              title={!canEdit ? editDisabledReason : 'Edit job'}
              onClick={() => canEdit && onEdit(job)}
            >
              <FaEdit />
            </button>
          )}
          {onDelete != null && (
            <button
              type="button"
              className="cs-btn-icon cs-btn-delete"
              disabled={!canDelete}
              title={!canDelete ? deleteDisabledReason : 'Delete job'}
              onClick={() => canDelete && onDelete(job)}
            >
              <FaTrash />
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default JobCard;
